import type { WidgetDefinition } from '../WidgetDefinition';
import { faRadar } from '@fortawesome/pro-regular-svg-icons/faRadar';
import type { LocatesV2WidgetModel } from '@thinkalpha/ui-types/contracts/workspace';
import { createDefaultLocatesV2Widget } from 'src/store/defaults/widget';
import type { LocatesV2WidgetViewModel } from 'src/store/types';

class LocatesV2WidgetDefinition implements WidgetDefinition<LocatesV2WidgetViewModel, LocatesV2WidgetModel> {
    type = 'lab' as const;
    nameKey = 'widgets::locates-v2::name' as const;
    roles = ['widgets::locates-v2', 'widgets::lab'];
    icon = faRadar;
    category = 'widgets::categories::trading' as const;
    defaultDimensions = { w: 0.6, h: 0.4, x: 0.2, y: 0.3 };
    /** All LAB v2 widgets share one Locates worker store, including its sort and filters. */
    maxInstances = 1;

    /**
     * Converts a LocatesV2 widget from contract model to view model.
     * Ensures all properties have correct default values when hydrating from saved workspaces.
     * Migrates old result_state sorts to createdAt desc (the new default).
     */
    toViewModel(widget: LocatesV2WidgetModel): LocatesV2WidgetViewModel {
        // Migrate old result_state sorts to createdAt desc
        // result_state is no longer a user-selectable sort option since it's always included first
        let migratedWidget = widget;
        if (
            widget.resultsTableColumns &&
            ((widget.resultsTableColumns.currentSort as unknown) === 'result_state desc' ||
                (widget.resultsTableColumns.currentSort as unknown) === 'result_state asc')
        ) {
            migratedWidget = {
                ...widget,
                resultsTableColumns: {
                    ...widget.resultsTableColumns,
                    currentSort: 'createdAt desc',
                },
            };
        }

        return createDefaultLocatesV2Widget(migratedWidget);
    }

    /**
     * Converts a LocatesV2 widget from view model to contract model
     */
    toContractModel(widget: LocatesV2WidgetViewModel): LocatesV2WidgetModel {
        return widget;
    }
}

export const locatesV2WidgetDefinition = new LocatesV2WidgetDefinition();
